import { useEditorState } from '@tiptap/react'
import type { CSSProperties } from 'react'
import { Icon } from '@opallabs/lapidary'
import { ColorRadioGroup } from '@opallabs/satellite'
import { useTextEditor } from '../../context'
import { ControlButtonPopover } from './ControlButtonPopover'
import * as styles from './styles'

export const HighlightControlButton = () => {
  const { editor } = useTextEditor()
  const activeColor: string | null = useEditorState({
    editor,
    selector: (snapshot) =>
      snapshot.editor.getAttributes('highlight').color ?? null,
  })

  const handleSelectColor = (color: string | null) => {
    if (color === null) {
      editor.chain().focus().unsetHighlight().run()
    } else {
      editor.chain().focus().toggleHighlight({ color }).run()
    }
  }

  return (
    <div
      css={styles.colorPopoverButtonWrapper}
      style={{ '--active-color': activeColor } as CSSProperties}
    >
      <ControlButtonPopover
        align="start"
        displayMenuIndicator={false}
        // See wrapped style above for the color underline that
        // appears below this icon in the button
        icon={<Icon glyph="gem-no-highlight" ariaHidden />}
        label="Highlight"
      >
        <div css={styles.colorPopoverContent}>
          <ColorRadioGroup
            useDefaultHighlightColors={true}
            hideColorInput={true}
            onSelectColor={handleSelectColor}
            selectedColor={activeColor}
          />
        </div>
      </ControlButtonPopover>
    </div>
  )
}
